var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contact-list-filters" },
    [
      _c("div", { staticClass: "filter-header" }, [
        _c("div", { staticClass: "filter-title" }, [
          _vm._v(_vm._s(_vm.$t("message.filters"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "material-icons close-icon",
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [_vm._v("close")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "filter-content" }, [
        _c("div", { staticClass: "filter-item" }, [
          _c(
            "div",
            {
              staticClass: "filter-label",
              on: {
                click: function ($event) {
                  return _vm.toggleDropdown("date")
                },
              },
            },
            [
              _vm._v("\n                Tarih\n                "),
              _c("div", { staticClass: "material-icons dropdown-icon" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.dropdowns.date ? "expand_less" : "expand_more") +
                    "\n                "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.dropdowns.date
            ? _c(
                "div",
                { staticClass: "filter-dropdown date-picker" },
                [
                  _c(
                    "a-select",
                    {
                      staticClass: "select-date",
                      on: {
                        change: function ($event) {
                          return _vm.setCustomDateFilter(
                            _vm.cloneFilters.timeSelect
                          )
                        },
                      },
                      model: {
                        value: _vm.cloneFilters.timeSelect,
                        callback: function ($$v) {
                          _vm.$set(_vm.cloneFilters, "timeSelect", $$v)
                        },
                        expression: "cloneFilters.timeSelect",
                      },
                    },
                    [
                      _c("a-select-option", { attrs: { value: "custom" } }, [
                        _vm._v(_vm._s(_vm.$t("time.custom"))),
                      ]),
                      _vm._v(" "),
                      _c("a-select-option", { attrs: { value: "today" } }, [
                        _vm._v(_vm._s(_vm.$t("time.today"))),
                      ]),
                      _vm._v(" "),
                      _c("a-select-option", { attrs: { value: "yesterday" } }, [
                        _vm._v(_vm._s(_vm.$t("time.yesterday"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-select-option",
                        { attrs: { value: "current-week" } },
                        [_vm._v(_vm._s(_vm.$t("time.currentWeek")))]
                      ),
                      _vm._v(" "),
                      _c("a-select-option", { attrs: { value: "last-week" } }, [
                        _vm._v(_vm._s(_vm.$t("time.lastWeek"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-select-option",
                        { attrs: { value: "current-month" } },
                        [_vm._v(_vm._s(_vm.$t("time.currentMonth")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-select-option",
                        { attrs: { value: "last-month" } },
                        [_vm._v(_vm._s(_vm.$t("time.lastMonth")))]
                      ),
                      _vm._v(" "),
                      _c("a-select-option", { attrs: { value: "last-30" } }, [
                        _vm._v(_vm._s(_vm.$t("time.last30Day"))),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.cloneFilters.timeSelect === "custom"
                    ? _c(
                        "div",
                        { staticClass: "custom-date-picker" },
                        [
                          _c("a-date-picker", {
                            attrs: {
                              disabledDate: _vm.disabledStartDate,
                              "show-time": "",
                              format: "YYYY-MM-DD HH:mm:ss",
                              placeholder: "Start",
                            },
                            on: { openChange: _vm.handleStartOpenChange },
                            model: {
                              value: _vm.cloneFilters.startDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.cloneFilters, "startDate", $$v)
                              },
                              expression: "cloneFilters.startDate",
                            },
                          }),
                          _vm._v(" "),
                          _c("a-date-picker", {
                            attrs: {
                              disabledDate: _vm.disabledEndDate,
                              "show-time": "",
                              format: "YYYY-MM-DD HH:mm:ss",
                              placeholder: "End",
                              open: _vm.endDateOpened,
                            },
                            on: { openChange: _vm.handleEndOpenChange },
                            model: {
                              value: _vm.cloneFilters.endDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.cloneFilters, "endDate", $$v)
                              },
                              expression: "cloneFilters.endDate",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-item" }, [
          _c(
            "div",
            {
              staticClass: "filter-label",
              on: {
                click: function ($event) {
                  return _vm.toggleDropdown("channels")
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.allChannels")) +
                  "\n                "
              ),
              _c("div", { staticClass: "material-icons dropdown-icon" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.dropdowns.channels ? "expand_less" : "expand_more"
                    ) +
                    "\n                "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.dropdowns.channels
            ? _c("div", { staticClass: "filter-dropdown" }, [
                _c(
                  "div",
                  { staticClass: "search-wrapper" },
                  [
                    _c("a-input", {
                      staticClass: "search-input",
                      attrs: { bordered: false },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "prefix",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "material-icons" }, [
                                  _vm._v("search"),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3791802071
                      ),
                      model: {
                        value: _vm.searchQueries.channels,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchQueries, "channels", $$v)
                        },
                        expression: "searchQueries.channels",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "channel-group",
                    on: {
                      click: function ($event) {
                        return _vm.toggleDropdown("whatsapp")
                      },
                    },
                  },
                  [
                    _c("WhatsappIcon", {
                      staticClass: "channel-group-icon",
                      attrs: { color: "#25D366" },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "channel-label" }, [
                      _vm._v("WhatsApp"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "material-icons dropdown-icon" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.dropdowns.whatsapp
                              ? "expand_less"
                              : "expand_more"
                          ) +
                          "\n                    "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.dropdowns.whatsapp
                  ? _c("div", { staticClass: "filter-dropdown" }, [
                      _c(
                        "div",
                        { staticClass: "checkbox-group" },
                        _vm._l(_vm.filteredWhatsappChannels, function (c) {
                          return _c(
                            "div",
                            {
                              key:
                                "channel-" +
                                c._id +
                                "-" +
                                _vm.isChecked("selectedChannelIds", c._id),
                              staticClass: "checkbox-item",
                              on: {
                                click: function ($event) {
                                  return _vm.toggleCheckbox(
                                    "selectedChannelIds",
                                    c._id
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "checkbox-item-label" },
                                [_vm._v(_vm._s(c.name))]
                              ),
                              _vm._v(" "),
                              _c("a-checkbox", {
                                attrs: {
                                  checked: _vm.isChecked(
                                    "selectedChannelIds",
                                    c._id
                                  ),
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "channel-group",
                    on: {
                      click: function ($event) {
                        return _vm.toggleDropdown("messenger")
                      },
                    },
                  },
                  [
                    _c("MessengerIcon", {
                      staticClass: "channel-group-icon",
                      attrs: { color: "#0088cc" },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "channel-label" }, [
                      _vm._v("Messenger"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "material-icons dropdown-icon" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.dropdowns.messenger
                              ? "expand_less"
                              : "expand_more"
                          ) +
                          "\n                    "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.dropdowns.messenger
                  ? _c("div", { staticClass: "filter-dropdown" }, [
                      _c(
                        "div",
                        { staticClass: "checkbox-group" },
                        _vm._l(_vm.filteredMessengerChannels, function (c) {
                          return _c(
                            "div",
                            {
                              key:
                                "channel-" +
                                c._id +
                                "-" +
                                _vm.isChecked("selectedChannelIds", c._id),
                              staticClass: "checkbox-item",
                              on: {
                                click: function ($event) {
                                  return _vm.toggleCheckbox(
                                    "selectedChannelIds",
                                    c._id
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "checkbox-item-label" },
                                [_vm._v(_vm._s(c.name))]
                              ),
                              _vm._v(" "),
                              _c("a-checkbox", {
                                attrs: {
                                  checked: _vm.isChecked(
                                    "selectedChannelIds",
                                    c._id
                                  ),
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "channel-group",
                    on: {
                      click: function ($event) {
                        return _vm.toggleDropdown("instagram")
                      },
                    },
                  },
                  [
                    _c("InstagramIcon", {
                      staticClass: "channel-group-icon",
                      attrs: { "special-background-mode": "" },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "channel-label" }, [
                      _vm._v("Instagram"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "material-icons dropdown-icon" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.dropdowns.instagram
                              ? "expand_less"
                              : "expand_more"
                          ) +
                          "\n                    "
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.dropdowns.instagram
                  ? _c("div", { staticClass: "filter-dropdown" }, [
                      _c(
                        "div",
                        { staticClass: "checkbox-group" },
                        _vm._l(_vm.filteredInstagramChannels, function (c) {
                          return _c(
                            "div",
                            {
                              key:
                                "channel-" +
                                c._id +
                                "-" +
                                _vm.isChecked("selectedChannelIds", c._id),
                              staticClass: "checkbox-item",
                              on: {
                                click: function ($event) {
                                  return _vm.toggleCheckbox(
                                    "selectedChannelIds",
                                    c._id
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "checkbox-item-label" },
                                [_vm._v(_vm._s(c.name))]
                              ),
                              _vm._v(" "),
                              _c("a-checkbox", {
                                attrs: {
                                  checked: _vm.isChecked(
                                    "selectedChannelIds",
                                    c._id
                                  ),
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-item" }, [
          _c(
            "div",
            {
              staticClass: "filter-label",
              on: {
                click: function ($event) {
                  return _vm.toggleDropdown("departments")
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.allDepartments")) +
                  "\n                "
              ),
              _c("div", { staticClass: "material-icons dropdown-icon" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.dropdowns.departments ? "expand_less" : "expand_more"
                    ) +
                    "\n                "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.dropdowns.departments
            ? _c("div", { staticClass: "filter-dropdown" }, [
                _c(
                  "div",
                  { staticClass: "search-wrapper" },
                  [
                    _c("a-input", {
                      staticClass: "search-input",
                      attrs: { bordered: false },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "prefix",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "material-icons" }, [
                                  _vm._v("search"),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3791802071
                      ),
                      model: {
                        value: _vm.searchQueries.departments,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchQueries, "departments", $$v)
                        },
                        expression: "searchQueries.departments",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "checkbox-group" },
                  _vm._l(_vm.filteredDepartments, function (d) {
                    return _c(
                      "div",
                      {
                        key:
                          "department-" +
                          d._id +
                          "-" +
                          _vm.isChecked("selectedDepartmentIds", d._id),
                        staticClass: "checkbox-item",
                        on: {
                          click: function ($event) {
                            return _vm.toggleCheckbox(
                              "selectedDepartmentIds",
                              d._id
                            )
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "checkbox-item-label" }, [
                          _vm._v(_vm._s(_vm.getDepartmentName(d))),
                        ]),
                        _vm._v(" "),
                        _c("a-checkbox", {
                          attrs: {
                            checked: _vm.isChecked(
                              "selectedDepartmentIds",
                              d._id
                            ),
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-item" }, [
          _c(
            "div",
            {
              staticClass: "filter-label",
              on: {
                click: function ($event) {
                  return _vm.toggleDropdown("agents")
                },
              },
            },
            [
              _vm._v("\n                Etkileşimdekiler\n                "),
              _c("div", { staticClass: "material-icons dropdown-icon" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.dropdowns.agents ? "expand_less" : "expand_more"
                    ) +
                    "\n                "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.dropdowns.agents
            ? _c("div", { staticClass: "filter-dropdown" }, [
                _c(
                  "div",
                  { staticClass: "search-wrapper" },
                  [
                    _c("a-input", {
                      staticClass: "search-input",
                      attrs: { bordered: false },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "prefix",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "material-icons" }, [
                                  _vm._v("search"),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        3791802071
                      ),
                      model: {
                        value: _vm.searchQueries.agents,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchQueries, "agents", $$v)
                        },
                        expression: "searchQueries.agents",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "checkbox-group" },
                  _vm._l(_vm.filteredUsers, function (u) {
                    return _c(
                      "div",
                      {
                        key:
                          "user-" +
                          u._id +
                          "-" +
                          _vm.isChecked("selectedUsers", u._id),
                        staticClass: "checkbox-item",
                        on: {
                          click: function ($event) {
                            return _vm.toggleCheckbox("selectedUsers", u._id)
                          },
                        },
                      },
                      [
                        _c("AgentAvatar", {
                          staticClass: "checkbox-item-agent",
                          attrs: { size: 20, userID: u._id, "font-size": 7 },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "checkbox-item-label" }, [
                          _vm._v(_vm._s(u.name)),
                        ]),
                        _vm._v(" "),
                        _c("a-checkbox", {
                          attrs: {
                            checked: _vm.isChecked("selectedUsers", u._id),
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "SupsisButton",
        { attrs: { primary: "" }, on: { click: _vm.filter } },
        [_vm._v("Uygula")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }